module.exports = __webpack_public_path__ + "static/goals_exploring_art@2x-a30572c2e0ad392332ab7aff41ed6ef8.png";